import React, { useState, useEffect, useRef } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from "common";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Modal, Grid, Typography, Box } from "@mui/material";
import Button from "components/CustomButtons/Button.js";
import CancelIcon from "@mui/icons-material/Cancel";
import AlertDialog from "../components/AlertDialog";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import { Autocomplete } from "@mui/material";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import BlockIcon from "@mui/icons-material/Block";
import { colors } from "../components/Theme/WebTheme";
import moment from "moment/min/moment-with-locales";
import { downloadCsv } from "../common/sharedFunctions";
import Badge from "@mui/material/Badge";
import {
    getStorage,
    ref,
    uploadBytes,
    getDownloadURL,
    deleteObject,
} from "firebase/storage";
import CarsListMultiService from "./CarsListMultiService";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    submit3: {
        width: "100%",
        borderRadius: 3,
        marginTop: 2,
        padding: 4,
    },
    paper: {
        width: 500,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        borderRadius: 15,
        alignItems: "center",
        justifyContent: "center",
    },
    imageGrid: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: "10px",
        justifyContent: "center",
        marginTop: "20px",
    },
    imageContainer: {
        position: "relative",
        width: "200px",
        height: "240px",
        border: "1px solid #ddd",
        borderRadius: "8px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
    },
    imageInput: {
        position: "absolute",
        bottom: "40px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1,
        marginLeft: "20px",
    },
    carImage: {
        width: "100%",
        height: "200px",
        objectFit: "cover",
    },
    imageLabel: {
        padding: "8px",
        textAlign: "center",
        backgroundColor: "#f5f5f5",
        borderTop: "1px solid #ddd",
        fontSize: "14px",
        color: "#666",
    },
}));

export default function CarsList() {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir();
    const settings = useSelector((state) => state.settingsdata.settings);
    const userdata = useSelector((state) => state.usersdata);
    const auth = useSelector((state) => state.auth);
    const [drivers, setDrivers] = useState([]);
    const [dataDrivers, setDataDrivers] = useState([]);
    const { updateUserCar, editCar } = api;
    const [driversObj, setDriversObj] = useState();
    const [fleetMapObj, setFleetMapObj] = useState([]);
    const [data, setData] = useState([]);
    const cartypes = useSelector((state) => state.cartypes);
    const carlistdata = useSelector((state) => state.carlistdata);
    const dispatch = useDispatch();
    const rootRef = useRef(null);
    const classes = useStyles();
    const [role, setRole] = useState(null);

    useEffect(() => {
        if (role !== "driver" && userdata.users) {
            let arr = userdata.users.filter(
                (user) =>
                    user.usertype === "driver" &&
                    ((role === "fleetadmin" &&
                        user.fleetadmin &&
                        user.fleetadmin === auth.profile.uid) ||
                        role === "admin")
            );
            let obj = {};
            let obj2 = {};
            let arr2 = [];
            for (let i = 0; i < arr.length; i++) {
                let user = arr[i];
                arr2.push({
                    id: user.id,
                    desc:
                        user.firstName +
                        " " +
                        user.lastName +
                        " (" +
                        (settings.AllowCriticalEditsAdmin
                            ? user.mobile
                            : "Hidden") +
                        ") " +
                        (settings.AllowCriticalEditsAdmin
                            ? user.email
                            : "Hidden"),
                });
                obj[user.id] =
                    user.firstName +
                    " " +
                    user.lastName +
                    " (" +
                    (settings.AllowCriticalEditsAdmin
                        ? user.mobile
                        : "Hidden") +
                    ") " +
                    (settings.AllowCriticalEditsAdmin ? user.email : "Hidden");
                obj2[user.id] = user.fleetadmin ? user.fleetadmin : null;
            }
            setDataDrivers(arr);
            setDrivers(arr2);
            setDriversObj(obj);
            setFleetMapObj(obj2);
        }
    }, [
        userdata.users,
        settings.AllowCriticalEditsAdmin,
        role,
        auth.profile.uid,
    ]);

    useEffect(() => {
        if (auth.profile && auth.profile.usertype) {
            setRole(auth.profile.usertype);
        }
    }, [auth.profile]);

    useEffect(() => {
        if (carlistdata.cars) {
            const cars = carlistdata.cars.filter(
                (car) => car.enabled === true && car.id !== "-"
            );
            setData(cars);
        } else {
            setData([]);
        }
    }, [carlistdata]);

    const [selectedImage, setSelectedImage] = useState(null);
    const handleProfileModal = (e) => {
        setProfileModal(false);
        setSelectedImage(null);
    };

    const [userData, setUserData] = useState();
    const [profileModal, setProfileModal] = useState(false);
    const [imageData, setImageData] = useState(false);
    const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
    const [loading, setLoading] = useState(false);

    const handleCommonAlertClose = (e) => {
        e.preventDefault();
        setCommonAlert({ open: false, msg: "" });
    };

    const handleSetProfileModal = (e) => {
        e.preventDefault();
        if (selectedImage) {
            setLoading(true);
            let finalData = userData;
            finalData.car_image = selectedImage;
            dispatch(editCar(finalData, "UpdateImage"));
            setProfileModal(false);
            setTimeout(() => {
                setSelectedImage(null);
                setLoading(false);
            }, 10000);
        } else {
            setCommonAlert({ open: true, msg: t("choose_image_first") });
        }
    };

    const onClick = (rowData) => {
        setImageData(rowData.car_image);
        setProfileModal(true);
        setUserData(rowData);
    };

    const [category, setCategory] = useState([]);
    const [categoryObj, setCategoryObj] = useState(null);
    const [carType, setCarType] = useState([]);
    const [carTypeObj, setCarTypeObj] = useState(null);

    const [selectCategory, setSelectCategory] = useState(null);
    const [driver, setDriver] = useState(null);
    const [selectCartype, setSelectCartype] = useState(null);

    const featureFlags = useSelector((state) => state.featureflagsdata.data);
    const addons = useSelector((state) => state.addondata);
    const [isMultiService, setIsMultiService] = useState(false);

    const handelchangeCategory = (event, newValue) => {
        setSelectCategory(newValue);
        setSelectCartype();
        if (cartypes.cars) {
            let arr = [];
            for (let i = 0; i < cartypes.cars.length; i++) {
                if (newValue) {
                    if (
                        newValue.value === cartypes.cars[i].category &&
                        cartypes.cars[i].active
                    ) {
                        arr.push({
                            label: t(cartypes.cars[i].name),
                            value: cartypes.cars[i].name,
                        });
                    }
                } else {
                    setCarType([]);
                }
            }
            setCarType(arr);
        }
    };

    const handelchangeDriver = (event, newValue) => {
        setDriver(newValue);
    };

    const handelchangeCartype = (event, newValue) => {
        setSelectCartype(newValue);
    };

    useEffect(() => {
        if (
            featureFlags &&
            featureFlags.add_on &&
            addons &&
            addons.data &&
            settings
        ) {
            console.log(
                "addons.data.multi_service",
                addons.data?.multi_service
            );
            setIsMultiService(
                addons.data?.multi_service && settings.multi_service
            );
        }
    }, [featureFlags, addons, settings]);

    useEffect(() => {
        if (cartypes.cars) {
            let arr = [];
            for (let i = 0; i < cartypes.cars.length; i++) {
                arr.push({
                    label: t(cartypes.cars[i].category),
                    value: cartypes.cars[i].category,
                });
            }
            let newArray = [];
            let uniqueObject = {};
            for (let i in arr) {
                let objTitle = arr[i]["label"];
                uniqueObject[objTitle] = arr[i];
            }
            for (let i in uniqueObject) {
                newArray.push(uniqueObject[i]);
            }
            setCategory(newArray);
        }
    }, [cartypes.cars, t]);

    useEffect(() => {
        if (cartypes.cars) {
            setCategoryObj(
                cartypes.cars[0] && cartypes.cars[0].category
                    ? cartypes.cars[0].category
                    : null
            );
        }
    }, [cartypes.cars]);

    useEffect(() => {
        if (cartypes.cars) {
            setCarTypeObj(
                cartypes.cars[0] && cartypes.cars[0].name
                    ? cartypes.cars[0].name
                    : null
            );
        }
    }, [cartypes.cars]);

    const columns = [
        {
            title: t("createdAt"),
            field: "createdAt",
            editable: "never",
            defaultSort: "desc",
            render: (rowData) =>
                rowData.createdAt
                    ? moment(rowData.createdAt).format("lll")
                    : null,
            cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
        },
        {
            title: t("driver"),
            field: "driver",
            editable: "onAdd",
            cellStyle: { textAlign: "center" },
            render: (rowData) => {
                if (rowData && rowData.driver) {
                    return driversObj && driversObj[rowData.driver]
                        ? driversObj[rowData.driver]
                        : null;
                }
            },
            editComponent: (props) => (
                <Autocomplete
                    id="combo-box-demo"
                    options={drivers}
                    getOptionLabel={(option) => option.desc}
                    style={{ width: 300 }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Combo box"
                            variant="outlined"
                        />
                    )}
                    onChange={handelchangeDriver}
                    disableClearable={true}
                    value={driver}
                />
            ),
            exportTransformer: (rowData) => driversObj[rowData.driver],
            hidden: role === "driver" ? true : false,
        },

        {
            title: t("category"),
            field: "category",
            cellStyle: { textAlign: "center" },
            render: (rowData) => {
                if (rowData && rowData.category) {
                    return t(rowData.category);
                }
            },
            editComponent: (props) => (
                <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={category}
                    sx={{ width: 200 }}
                    renderInput={(params) => (
                        <TextField {...params} label={t("category")} />
                    )}
                    onChange={handelchangeCategory}
                    disableClearable={true}
                    value={selectCategory}
                />
            ),
            exportTransformer: (rowData) =>
                rowData.category
                    ? t(rowData.category)
                    : categoryObj[rowData.category],
            editable: "onAdd",
        },

        {
            title: t("carType"),
            field: "carType",
            cellStyle: { textAlign: "center" },
            render: (rowData) => {
                if (rowData && rowData.carType) {
                    return t(rowData.carType);
                }
            },
            editComponent: (props) => (
                <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={carType}
                    sx={{ width: 200 }}
                    renderInput={(params) => (
                        <TextField {...params} label={t("carType")} />
                    )}
                    onChange={handelchangeCartype}
                    disableClearable={true}
                    value={selectCartype}
                />
            ),
            exportTransformer: (rowData) => carTypeObj[rowData.carType],
            editable: "onAdd",
        },
        { title: t("vehicle_reg_no"), field: "vehicleNumber" },
        { title: t("vehicle_model_name"), field: "vehicleMake" },
        { title: t("vehicle_model_no"), field: "vehicleModel" },
        { title: t("other_info"), field: "other_info" },
        {
            title: t("image"),
            field: "car_image",
            initialEditValue:
                "https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png",
            render: (rowData) =>
                rowData.car_image ? (
                    <Badge
                        overlap="circular"
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        badgeContent={
                            isMultiService
                                ? `+${(rowData.car_images?.length || 1) - 1}`
                                : null
                        }
                        color={rowData.active ? "success" : "error"}
                        invisible={!isMultiService}
                    >
                        <button
                            onClick={() => {
                                // console.log("rowData", rowData);
                                if (isMultiService) {
                                    handleMultiImageModal(rowData);
                                } else {
                                    onClick(rowData);
                                }
                            }}
                        >
                            <img
                                alt="CarImage"
                                src={rowData.car_image}
                                style={{ width: 50 }}
                            />
                        </button>
                    </Badge>
                ) : null,
        },
        {
            title: t("active_status"),
            field: "active",
            editable: role === "admin" ? "never" : "always",
            type: "boolean",
        },
        {
            title: "Enabled",
            field: "enabled",
            editable: role === "admin" ? "always" : "never",
            type: "boolean",
            initialEditValue: true,
        },
        {
            title: t("approved"),
            field: "approved",
            editable: role === "admin" ? "always" : "never",
            type: "boolean",
        },
    ];

    const [selectedRow, setSelectedRow] = useState(null);

    const [multiImageModal, setMultiImageModal] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);
    const [currentCarData, setCurrentCarData] = useState(null);

    const handleMultiImageModal = (rowData) => {
        // console.log("handleMultiImageModal rowData", rowData);
        setCurrentCarData(rowData);
        setSelectedImages(rowData.car_images || [rowData.car_image]);
        setMultiImageModal(true);
    };

    const handleImageChange = (index, file) => {
        if (file) {
            const newImages = [...selectedImages];
            const imageUrl = URL.createObjectURL(file);
            newImages[index] = {
                ...newImages[index],
                image: imageUrl,
                file: file,
            };
            // console.log("newImages", newImages);
            setSelectedImages(newImages);
        }
    };

    const deleteImageFromFirebase = async (carId, label) => {
        try {
            const storage = getStorage();
            const storageRef = ref(storage, `cars/${carId}_${label}`);
            await deleteObject(storageRef);
            // console.log("Deleted old image:", `cars/${carId}_${label}`);
        } catch (error) {
            // If the file doesn't exist, we can ignore the error
            if (error.code !== "storage/object-not-found") {
                // console.error("Error deleting image:", error);
            }
        }
    };

    const uploadImageToFirebase = async (file, carId, label) => {
        try {
            // First delete the old image if it exists
            await deleteImageFromFirebase(carId, label);

            const storage = getStorage();
            const storageRef = ref(storage, `cars/${carId}_${label}`);

            // Upload the file
            const snapshot = await uploadBytes(storageRef, file);

            // Get the download URL
            const downloadURL = await getDownloadURL(snapshot.ref);

            return downloadURL;
        } catch (error) {
            // console.error("Error uploading image:", error);
            throw error;
        }
    };

    const handleSaveMultiImages = async () => {
        if (currentCarData) {
            setLoading(true);
            try {
                const updatedImages = [];
                await Promise.all(
                    selectedImages.map(async (img, index) => {
                        if (img.file) {
                            // console.log("uploading image", currentCarData.id, img.label);
                            const downloadURL = await uploadImageToFirebase(
                                img.file,
                                currentCarData.id,
                                img.label
                            );
                            // console.log("upload downloadURL", downloadURL);
                            updatedImages.push({
                                image: downloadURL,
                                label: img.label,
                            });
                        } else if (img.image) {
                            updatedImages.push({
                                image: img.image,
                                label: img.label,
                            });
                        }
                    })
                );

                const filteredImages = updatedImages.filter(
                    (img) => img !== null
                );
                // console.log("filteredImages", filteredImages);
                let finalData = {
                    ...currentCarData,
                    car_images: filteredImages,
                    car_image: filteredImages[0].image,
                };

                // console.log("finalData", finalData);
                dispatch(editCar(finalData, "UpdateImage", false));
                setMultiImageModal(false);
            } catch (error) {
                // console.error("Error saving images:", error);
                setCommonAlert({ open: true, msg: t("image_upload_error") });
            } finally {
                setLoading(false);
                setSelectedImages([]);
                setCurrentCarData(null);
            }
        }
    };

    return carlistdata.loading ? (
        <CircularLoading />
    ) : (
        <div ref={rootRef}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                }}
            >
                <CarsListMultiService
                    dataDrivers={dataDrivers}
                    drivers={drivers}
                    dataCars={data}
                    t={t}
                    onDataCarsChange={setData}
                    onHandleMultiImage={handleMultiImageModal}
                />

                {/* <MaterialTable
          title={t("cars")}
          columns={columns}
          style={{
            direction: isRTL === "rtl" ? "rtl" : "ltr",
            borderRadius: "8px",
            boxShadow: "4px 4px 6px #9E9E9E",
          }}
          data={data}
          onRowClick={(evt, selectedRow) =>
            setSelectedRow(selectedRow.tableData.id)
          }
          options={{
            exportCsv: (columns, data) => {
              let hArray = [];
              const headerRow = columns.map((col) => {
                if (typeof col.title === "object") {
                  return col.title.props.text;
                }
                hArray.push(col.field);
                return col.title;
              });
              const dataRows = data.map(({ tableData, ...row }) => {
                row.createdAt = row.createdAt
                  ? new Date(row.createdAt).toLocaleDateString() +
                  " " +
                  new Date(row.createdAt).toLocaleTimeString()
                  : "";
                let dArr = [];
                for (let i = 0; i < hArray.length; i++) {
                  dArr.push(row[hArray[i]]);
                }
                return Object.values(dArr);
              });
              const { exportDelimiter } = ",";
              const delimiter = exportDelimiter ? exportDelimiter : ",";
              const csvContent = [headerRow, ...dataRows]
                .map((e) => e.join(delimiter))
                .join("\n");
              const csvFileName = "cars.csv";
              downloadCsv(csvContent, csvFileName);
            },
            exportButton: {
              csv: settings.AllowCriticalEditsAdmin,
              pdf: false,
            },
            rowStyle: (rowData) => ({
              backgroundColor:
                selectedRow === rowData.tableData.id
                  ? colors.THIRDCOLOR
                  : colors.WHITE,
            }),
            editable: {
              backgroundColor: colors.WHITE,
              fontSize: "0.8em",
              fontWeight: "bold ",
              fontFamily: 'Lucida Console", "Courier New", monospace',
            },
            cellStyle: { textAlign: "center" },
            headerStyle: {
              position: "sticky",
              textAlign: "center",
              top: "0px",
              backgroundColor: colors.SECONDARY,
              color: colors.WHITE,
              fontSize: "0.8em",
              fontWeight: "bold ",
              fontFamily: 'Lucida Console", "Courier New", monospace',
            },
          }}
          localization={{
            body: {
              addTooltip: t("add"),
              deleteTooltip: t("delete"),
              editTooltip: t("edit"),
              emptyDataSourceMessage: t("blank_message"),
              editRow: {
                deleteText: t("delete_message"),
                cancelTooltip: t("cancel"),
                saveTooltip: t("save"),
              },
            },
            toolbar: {
              searchPlaceholder: t("search"),
              exportTitle: t("export"),
            },
            header: {
              actions: t("actions"),
            },
            pagination: {
              labelDisplayedRows: "{from}-{to} " + t("of") + " {count}",
              firstTooltip: t("first_page_tooltip"),
              previousTooltip: t("previous_page_tooltip"),
              nextTooltip: t("next_page_tooltip"),
              lastTooltip: t("last_page_tooltip"),
            },
          }}
          editable={{
            onRowAdd: (newData) =>
              settings.AllowCriticalEditsAdmin
                ? new Promise((resolve, reject) => {
                  setTimeout(() => {
                    if (
                      newData &&
                      selectCartype.value &&
                      selectCategory.value &&
                      newData.vehicleNumber &&
                      newData.vehicleMake &&
                      newData.vehicleModel &&
                      newData.other_info &&
                      newData.car_image
                    ) {
                      let selectDriver =
                        role === "admin" || role === "fleetadmin"
                          ? driver.id
                          : auth.profile.uid;
                      let activeCar = null;
                      let updateData = {
                        carType: selectCartype.value,
                        category: selectCategory.value,
                        vehicleNumber: newData.vehicleNumber,
                        vehicleMake: newData.vehicleMake,
                        vehicleModel: newData.vehicleModel,
                        other_info: newData.other_info,
                        car_image: newData.car_image,
                        createdAt: new Date().getTime(),
                        driver: selectDriver,
                      };
                      // Allow multiple cars to be active simultaneously
                      if (newData.active) {
                        // Sync enabled with active status
                        newData.enabled = true;
                        // Update driver's carType and category for backend compatibility
                        const driverToUpdate = {
                          ...updateData,
                          carType: newData.carType || selectCartype.value,
                          category: newData.category || selectCategory.value
                        };
                        dispatch(updateUserCar(selectDriver, driverToUpdate));
                      } else {
                        // Sync enabled with active status
                        newData.enabled = false;
                      }
                      if (role === "driver") {
                        newData["driver"] = selectDriver;
                      }
                      newData["createdAt"] = new Date().getTime();
                      newData["fleetadmin"] = newData["driver"]
                        ? fleetMapObj[newData["driver"]]
                          ? fleetMapObj[newData["driver"]]
                          : null
                        : null;
                      if (!settings.carApproval) {
                        newData["approved"] = true;
                        if (newData.active && !settings.multi_service) {
                          dispatch(
                            updateUserCar(selectDriver, { carApproved: true })
                          );
                        }
                      } else {
                        newData["approved"] = false;
                      }
                      let updateCaeData = {
                        ...updateData,
                        active: newData.active,
                        enabled: newData.enabled !== undefined ? newData.enabled : newData.active, // Sync enabled with active
                        approved: newData.approved,
                        fleetadmin:
                          role === "fleetadmin" ? auth.profile.uid : null,
                      };
                      dispatch(editCar(updateCaeData, "Add"));
                      setSelectCategory();
                      setDriver();
                      setSelectCartype();
                      resolve();
                    } else {
                      alert(t("proper_input_name"));
                      reject();
                    }
                  }, 600);
                })
                : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(t("demo_mode"));
                  }, 600);
                }),
            onRowUpdate: (newData, oldData) =>
              settings.AllowCriticalEditsAdmin
                ? new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    if (newData !== oldData) {
                      let activeCar = null;
                      let updateData = {
                        carType: newData.carType,
                        category: newData.category,
                        vehicleNumber: newData.vehicleNumber,
                        vehicleMake: newData.vehicleMake,
                        vehicleModel: newData.vehicleModel,
                        other_info: newData.other_info,
                        car_image: newData.car_image,
                        updateAt: new Date().getTime(),
                      };
                      for (let i = 0; i < data.length; i++) {
                        if (
                          data[i].driver === newData.driver &&
                          data[i].active
                        ) {
                          activeCar = data[i];
                          break;
                        }
                      }
                      if (activeCar && newData.active) {
                        activeCar.active = false;
                        dispatch(editCar(activeCar, "Update"));
                        // Update driver's carType and category for backend compatibility
                        const driverToUpdate = {
                          ...updateData,
                          carType: newData.carType,
                          category: newData.category
                        };
                        dispatch(updateUserCar(newData.driver, driverToUpdate));
                      } else if (activeCar && !newData.active) {
                        newData.active = false;
                        newData.enabled = false; // Sync enabled with active
                      } else {
                        newData.active = true;
                        newData.enabled = true; // Sync enabled with active
                        // Update driver's carType and category for backend compatibility
                        const driverToUpdate = {
                          ...updateData,
                          carType: newData.carType,
                          category: newData.category
                        };
                        dispatch(updateUserCar(newData.driver, driverToUpdate));
                      }
                      newData["fleetadmin"] = newData["fleetadmin"]
                        ? fleetMapObj[newData["driver"]]
                        : null;
                      delete newData.tableData;
                      dispatch(editCar(newData, "Update"));
                      if (newData.driver !== oldData.driver && oldData.driver) {
                        dispatch(
                          updateUserCar(oldData.driver, {
                            carType: null,
                            vehicleNumber: null,
                            vehicleMake: null,
                            vehicleModel: null,
                            other_info: null,
                            car_image: null,
                            updateAt: new Date().getTime(),
                          })
                        );
                      }
                    }
                  }, 600);
                })
                : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(t("demo_mode"));
                  }, 600);
                }),
            onRowDelete: (oldData) =>
              settings.AllowCriticalEditsAdmin
                ? new Promise((resolve, reject) => {
                  setTimeout(() => {
                    if (oldData.active) {
                      reject();
                      alert(t("active_car_delete"));
                    } else {
                      resolve();
                      dispatch(editCar(oldData, "Delete"));
                    }
                  }, 600);
                })
                : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(t("demo_mode"));
                  }, 600);
                }),
          }}
          actions={[
            (rowData) =>
              settings.carApproval && role === "admin"
                ? {
                  icon: () =>
                    rowData.approved ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                        }}
                      >
                        <BlockIcon />
                        <Typography variant="subtitle2">
                          {t("reject")}
                        </Typography>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                        }}
                      >
                        <DoneAllIcon />
                        <Typography variant="subtitle2">
                          {t("accept")}
                        </Typography>
                      </div>
                    ),
                  onClick: (event, rowData) => {
                    if (rowData.active) {
                      dispatch(
                        updateUserCar(rowData.driver, {
                          carApproved: true,
                        })
                      );
                    }
                    dispatch(
                      editCar(
                        { ...rowData, approved: !rowData.approved },
                        "Update"
                      )
                    );
                  },
                }
                : null,
          ]}
        /> */}
            </Box>
            <Modal
                disablePortal
                disableEnforceFocus
                disableAutoFocus
                open={profileModal}
                onClose={handleProfileModal}
                className={classes.modal}
                container={() => rootRef.current}
            >
                <Grid
                    container
                    spacing={1}
                    className={classes.paper}
                    style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                >
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Typography component="h1" variant="h6">
                            {t("car_image")}
                            <input
                                type="file"
                                style={{ marginLeft: 10 }}
                                name={t("image")}
                                onChange={(event) => {
                                    setSelectedImage(event.target.files[0]);
                                }}
                            />
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        {selectedImage && !loading ? (
                            <Tooltip title={t("cancel")}>
                                <CancelIcon
                                    onClick={() => setSelectedImage(null)}
                                    style={{
                                        fontSize: 30,
                                        backgroundColor: colors.RED,
                                        borderRadius: 50,
                                        color: colors.WHITE,
                                    }}
                                />
                            </Tooltip>
                        ) : null}
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        {selectedImage ? (
                            <img
                                alt="not fount"
                                width={"200px"}
                                height={"200px"}
                                src={URL.createObjectURL(selectedImage)}
                                style={{ marginTop: 15, marginBottom: 20 }}
                            />
                        ) : (
                            <img
                                alt="not fount"
                                width={"200px"}
                                height={"200px"}
                                src={imageData}
                                style={{ marginTop: 10 }}
                            />
                        )}
                        <br />
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        style={{
                            textAlign: isRTL === "rtl" ? "right" : "left",
                        }}
                    >
                        {loading ? (
                            <Grid
                                container
                                spacing={0}
                                alignItems="center"
                                justify="center"
                                style={{ minHeight: "5vh" }}
                            >
                                <CircularProgress />
                            </Grid>
                        ) : (
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                style={{
                                    textAlign:
                                        isRTL === "rtl" ? "right" : "left",
                                }}
                            >
                                <Button
                                    onClick={handleProfileModal}
                                    variant="contained"
                                    color="danger"
                                >
                                    {t("cancel")}
                                </Button>
                                <Button
                                    onClick={handleSetProfileModal}
                                    variant="contained"
                                    color="success"
                                    style={{ marginLeft: 10 }}
                                >
                                    {t("save")}
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Modal>

            {selectedImages.length > 1 && (
                <Modal
                    open={multiImageModal}
                    onClose={() => setMultiImageModal(false)}
                    className={classes.modal}
                    container={() => rootRef.current}
                >
                    <Grid
                        container
                        spacing={1}
                        className={classes.paper}
                        style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                    >
                        <Grid item xs={12}>
                            <Typography component="h1" variant="h6">
                                {t("car_images")}
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Box className={classes.imageGrid}>
                                {[0, 1, 2, 3].map((index) => (
                                    <Box
                                        key={index}
                                        className={classes.imageContainer}
                                    >
                                        <img
                                            src={
                                                selectedImages[index]?.image ||
                                                "https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png"
                                            }
                                            alt={`Car ${index + 1}`}
                                            className={classes.carImage}
                                        />
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) =>
                                                handleImageChange(
                                                    index,
                                                    e.target.files[0]
                                                )
                                            }
                                            className={classes.imageInput}
                                        />
                                        <div className={classes.imageLabel}>
                                            {t(selectedImages[index]?.label) ||
                                                `Image ${index + 1}`}
                                        </div>
                                    </Box>
                                ))}
                            </Box>
                        </Grid>

                        <Grid
                            item
                            xs={12}
                            style={{ textAlign: "right", marginTop: "20px" }}
                        >
                            <Button
                                onClick={() => setMultiImageModal(false)}
                                variant="contained"
                                color="danger"
                                style={{ marginRight: "10px" }}
                            >
                                {t("cancel")}
                            </Button>
                            <Button
                                onClick={handleSaveMultiImages}
                                variant="contained"
                                color="success"
                                disabled={loading}
                            >
                                {loading ? (
                                    <CircularProgress size={24} />
                                ) : (
                                    t("save")
                                )}
                            </Button>
                        </Grid>
                    </Grid>
                </Modal>
            )}
            <AlertDialog
                open={commonAlert.open}
                onClose={handleCommonAlertClose}
            >
                {commonAlert.msg}
            </AlertDialog>
        </div>
    );
}
